import * as React from "react"

/** A three-quarter circle that the spinner and loading states turn with `animate-spin`. */
function SpinnerArc(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 3a9 9 0 1 0 9 9" />
    </svg>
  )
}

export { SpinnerArc }
